
export const tourData = [
{id:1,
city:"diani",
img:"./img/diani.jpg",
name:"beach holiday",
info:"visit diani to enjoy best vacation across great beaches"
},
{id:2,
city:"the rift",
img:"./img/hells gate.jpg",
name:"hells gate tour",
info: "ideal venue for a trip in addition to bio-divertsity and rock climbing"
},
{id:3,
city:"naivasha",
img:"./img/naivasha.jpg",
name:"lake naivasha visit",
info:"the beautiful freshwater lake with great scenic views and wilflife attractions", 
},
{
id:4,
city:"the mara",
img:"./img/mara.jpg",
name:"the mara safari",
info:"the popular safari destination across africa with the great wilderbeast migration"}
]